import React from 'react';
import SvgIcon from './SvgIcon';

const ColdWave = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M8.775 1.275L12 4.5l3.225-3.225m-6.45 21.45L12 19.5l3.225 3.225m-13.95-7.5L4.5 12 1.275 8.775m21.45 6.45L19.5 12l3.225-3.225M2.175 6.75H6.75V2.175m10.5 19.65V17.25h4.575M6.75 21.825V17.25H2.175m19.65-10.5H17.25V2.175M19.95 4.05l-15.9 15.9M.75 12h22.5H.75zM12 .75v22.5V.75zm-7.95 3.3l15.9 15.9-15.9-15.9z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

ColdWave.displayName = 'ColdWaveIcon';

export default ColdWave;
